import React from 'react';
import { getEmailChain, useAppSelector } from 'app/redux';
import styles from './TextInput.module.scss';

export const TextInput: React.FC = () => {
  const currentEmailChain = useAppSelector(getEmailChain);

  return currentEmailChain != null ? (
    <div className={styles['uploaded-document']}>
      <h3>Claims email provided</h3>
      <div className={styles['claims-email-summary']}>{currentEmailChain}</div>
    </div>
  ) : (
    <></>
  );
};
